import { render, staticRenderFns } from "./SanjivaniStudentIcard.vue?vue&type=template&id=196559ee&scoped=true&"
import script from "./SanjivaniStudentIcard.vue?vue&type=script&lang=js&"
export * from "./SanjivaniStudentIcard.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniStudentIcard.vue?vue&type=style&index=0&id=196559ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196559ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VRadio,VRadioGroup,VRow,VTextarea})
